import React from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import Navbar from '../Shared/Navbar/Navbar';
import google from '../../assets/images/google.png';

const Register = () => {
    const { register, handleSubmit, reset } = useForm();
    const location = useLocation();
    const history = useHistory();
    const { user, registerUser, signInWithGoogle } = useAuth();
    const onSubmit = data => {
        registerUser(data.email, data.password, data.name, history);
        reset();
    };

    const handleGoogleSignIn = () => {
        signInWithGoogle(location, history);
    }
    return (
        <div>
            <Navbar />
            <div style={{ padding: '100px' }} className='container'>
                <h2 className='title text-center'>Be our Member!</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <input style={{ fontFamily: 'Poppins' }} className='m-3 w-50' {...register("name")} placeholder=' Full Name' />
                    <br />
                    <input style={{ fontFamily: 'Poppins' }} className='m-3 w-50' {...register("email")} placeholder=' Email' />
                    <br />
                    <input style={{ fontFamily: 'Poppins' }} className='m-3 w-50' {...register("password")} type='password' placeholder=' Password' />
                    <input style={{ fontFamily: 'Poppins' }} className='m-3 w-50' {...register("password2")} type='password' placeholder=' Confirm Password' />
                    <br />
                    <input style={{ backgroundColor: 'black', color: 'white', fontFamily: 'Poppins', border: 'none' }} className='m-3 w-25' type="submit" value='Register' />
                </form>
                <h5 style={{ fontFamily: 'Poppins' }} className='m-3'>Already a Member? Please <Link style={{ color: 'blue' }} to='/login'>Login</Link> </h5>
                {
                    user.email && <div style={{ fontFamily: 'Poppins' }} className="alert alert-success m-3 w-50" role="alert">
                        Thanks for joining! 🔥
                    </div>
                }
                <br />
                <p style={{ fontFamily: 'Poppins' }} className='m-3'>or</p>
                <br />
                <button style={{ backgroundColor: 'black', color: 'white', border: 'none', padding: '20px' }} onClick={handleGoogleSignIn}> <img style={{ width: '20px' }} src={google} alt="" />  Google Sign In</button>
            </div>
        </div>
    );
};

export default Register;